import React, { useState, 
                useEffect } from 'react';
import ProgressBar          from 'react-bootstrap/ProgressBar';

function ProgressBarItem( { actualValue, totalValue, displayText, className } ) {
    const [actual, setActual]    = useState( 0 );
    const [total, setTotal]      = useState( 1 );
    const [display, setDisplay] = useState( "" );

    useEffect(() => {
        if (typeof actualValue !== 'undefined') {
            setActual(actualValue);
        }
        if (typeof totalValue !== 'undefined') {
            setTotal( totalValue );
        }
        if (typeof displayText !== 'undefined') {
            setDisplay( displayText );
        }
        
    }, [actualValue, totalValue, displayText]);

    return(<ProgressBar className={className}>
             <ProgressBar variant="progress-so-far" label={display} now={ 100.0 - (Number(actual) / Number(total) * 100.0)} key={1} />
             <ProgressBar variant="progress-spare" label={ (1.0 - (Number(actual)/Number(total)) < 0.3) ? ( display + " " + Number( 100.0 - (Number(actual) / Number(total) * 100.0)).toFixed(2) + '%') : (Number( 100.0 - (Number(actual) / Number(total) * 100.0)).toFixed(2) + '%')} now={(Number(actual) / Number(total) * 100.0 )} key={2} />
           </ProgressBar>);
}

export default ProgressBarItem;
